import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ title, description, img }) => (
  <Link to="#" className="block group">
    <div className="relative rounded-[10px] overflow-hidden">
      <img src={img} alt={title} className="w-full h-[500px] object-cover" />
      <div
        className="absolute bottom-0 h-[426px] w-full"
        style={{
          background:
            'linear-gradient(180deg, rgba(15, 15, 15, 0) 0%, rgba(15, 15, 15, 0.8) 100%)',
        }}
      />
      <div className="absolute left-[33.38px] right-[33.38px] bottom-[38.37px] text-white">
        <h4 className="text-[22px] leading-[28px] font-normal libre-baskerville mb-2">
          {title}
        </h4>
        <p className="text-[14px] text-[#CCCCCC] leading-[24px] font-medium">
          {description}
        </p>
      </div>
    </div>
  </Link>
);

const categories = [
  { title: 'Polo Shirts', img: '/assets/workware-categories-1.webp' },
  { title: 'Jackets', img: '/assets/workware-categories-2.webp' },
  { title: 'Shoes', img: '/assets/workware-categories-3.webp' },
  { title: 'Pants', img: '/assets/workware-categories-4.webp' },
  { title: 'T-Shirts', img: '/assets/workware-categories-5.webp' },
  { title: 'Shorts', img: '/assets/workware-categories-6.webp' },
].map((c) => ({
  ...c,
  description:
    'Workwear designed for professionals who demand comfort, safety, and endurance in every task.',
}));

// const gridItems = Array.from({ length: 8 }).map((_, i) => ({
//   id: i + 1,
//   name: 'Jacket',
//   price: i % 4 === 0 ? '395,00 €' : '390,00 €',
//   image: '/assets/product-image.webp',
// }));

const WorkwareCategories = () => {
  return (
    <div>
      <div className="px-4 sm:px-6 xl:px-8 py-14 md:py-[100px] flex items-center justify-center flex-col gap-4">
        <h1 className="text-[#000000] text-[32px] sm:text-[60px] lg:text-[94px] leading-[40px] sm:leading-[70px] lg:leading-[117px] font-normal libre-baskerville">
          Workwear
        </h1>
        <a
          href="/product"
          className="border border-[#000000] rounded-[9px] h-[40px] text-[#000000] text-[12px] leading-[20px] font-medium flex items-center justify-center pr-2 pl-4"
        >
          Go To Product
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.3281 9C15.5156 9 15.6771 9.0625 15.8125 9.1875L20.4688 13.8594C20.6042 13.9844 20.6719 14.1406 20.6719 14.3281C20.6719 14.5156 20.6042 14.6771 20.4688 14.8125L15.8125 19.4688C15.6771 19.6042 15.5156 19.6719 15.3281 19.6719C15.1406 19.6719 14.9844 19.6042 14.8594 19.4688C14.7344 19.3438 14.6719 19.1875 14.6719 19C14.6719 18.8125 14.7344 18.6562 14.8594 18.5312L18.3906 15H8C7.8125 15 7.65625 14.9323 7.53125 14.7969C7.39583 14.6719 7.32812 14.5156 7.32812 14.3281C7.32812 14.151 7.39583 13.9948 7.53125 13.8594C7.65625 13.7344 7.8125 13.6719 8 13.6719H18.3906L14.8594 10.1406C14.7344 10.0156 14.6719 9.85938 14.6719 9.67188C14.6719 9.47396 14.7344 9.3125 14.8594 9.1875C14.9844 9.0625 15.1406 9 15.3281 9Z"
              fill="black"
            />
          </svg>
        </a>
      </div>
      <div className="w-full bg-[#EDEDED] px-4 sm:px-6 xl:px-8 py-10 sm:pt-20 sm:pb-20 md:pb-[104px] mb-20 md:mb-[120px]">
        <div className="max-w-[1300px] w-full mx-auto">
          <h2 className="text-[#1D1D1F] libre-baskerville font-normal text-[32px] sm:text-[46px] leading-[40px] sm:leading-[57px] mb-6 text-center sm:text-left">
            Workware Categories
          </h2>
          <p className="text-[#6E6E73] text-[17px] leading-[23px] font-medium max-w-[400px] text-center sm:text-left">
            Six product lines. One promise: performance and quality you can
            trust.
          </p>
          <div className="mt-[56px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {categories.map((c) => (
              <CategoryCard key={c.title} {...c} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkwareCategories;
